import styles from './home-page.module.css';

export const HomePage = () => <h1 className={styles.heading}>Powerpuff Girls Home page</h1>;
